var _style, _path, _tspan, _tspan2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1288.8 344.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st0{fill:#F4F4F4;stroke:#F4F4F4;stroke-width:2;stroke-miterlimit:10;}\n    .st2{fill:#0c05bb;fill-opacity:0.86528498;}\n    .st3{fill:#0a03b6;fill-opacity:0.80829018;}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,7.5h150.5c49.2,0,89.1,39.9,89.1,89.1v150.5c0,49.2-39.9,89.1-89.1,89.1H97.9c-49.2,0-89.1-39.9-89.1-89.1V96.6C8.8,47.4,48.7,7.5,97.9,7.5z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.260216,0,0,1.2526729,-219.83054,-38.988672)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 485.58185,
    y: 265.50427,
    transform: "scale(1.0009948,0.99900616)",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "295.969px",
      fontFamily: "'Times New Roman'",
      strokeWidth: 1.54151
    },
    className: "st2"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 485.58185,
    y: 265.50427
  }, "Jesse")))), /*#__PURE__*/React.createElement("text", {
    x: 48.817822,
    y: 292.73645,
    transform: "scale(1.1563752,0.86477123)",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: "bold",
      fontStretch: "normal",
      fontSize: "376.55px",
      fontFamily: "'Savoye LET'",
      strokeWidth: 1.96119
    },
    className: "st3"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 48.817822,
    y: 292.73645
  }, "J"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.979e81e7d7c97d7fa8fa4b1f7e875766.svg";
export { ForwardRef as ReactComponent };